// Main exports
export { KycModal } from "./widgets/kyc/KycModal";
export { ManageCardModal } from "./widgets/dashboard/ManageCardModal";

// Card activation exports
export { createCardAction } from "./core/createCard";
export { delegateAmount } from "./core/delegateAmount";
export { updateCardProvider } from "./core/updateCardProvider";
export {
  handleUpdateCardHook,
  handleDeleteCardHook,
} from "./core/cardHookMethods";
export {
  showCardDetails,
  ensureRainScriptLoaded,
  updateCardPin,
} from "./core/random";

// SDK exports
export { initializeSwypeSDK } from "./api/sdk";
export {
  // Auth exports
  generateAuthSign,
  initializeAuth,
  refreshAuth,
  // Passkey auth exports
  getPasskeys,
  deletePasskey,
  beginDiscoverablePasskeyLogin,
  beginPasskeyRegistration,
  finishDiscoverablePasskeyLogin,
  finishPasskeyRegistration,
} from "./api/auth";
export {
  getEulerCardPreview,
  getEulerHealthFactor,
  getPendingTransactionBalance,
  getEulerTotalAsset,
  getOnchainTransactionDetails,
} from "./api/api";

// Store exports
export { useKycStore } from "./stores/useKycStore";

// Hook exports
export { useCardData } from "./hooks/useCardData";
export { useCreditData } from "./hooks/useCreditData";
export { useGetTransactions } from "./hooks/useGetTransactions";
export { useGetHookTransactions } from "./hooks/useGetHookTransactions";
export { useRewardsData } from "./hooks/useRewardsData";
export { useXPHistory } from "./hooks/useXPHistory";
export { useReferralEarnings } from "./hooks/useReferralEarnings";
export type { CardDetailsCallbacks } from "./hooks/useCardDetails";

// Type exports
export type {
  CardStatus,
  UserCard,
  Transaction,
  OnchainTransactionDetail,
  EulerTotalAssetResponse,
  CreditInformationResponse,
  AaveCreditMetadata,
  EulerCreditMetadata,
  HypurrFiWithdrawCreditMetadata,
  FelixWithdrawCreditMetadata,
  HyperBeatWithdrawCreditMetadata,
  HyperLendWithdrawCreditMetadata,
  HypurrFiWithdrawSuppliedAsset,
  SuppliedAsset,
  BorrowedAsset,
  MorphoCreditAsset,
  EulerPosition,
  UserParams,
  HookType,
  HookConfig,
  HookTransaction,
  JWT,
  PasskeyRegistrationBeginResponse,
  PasskeyLoginBeginResponse,
  PasskeyDiscoverableLoginBeginResponse,
  WebAuthnCredential,
  XPHistoryEntry,
  XPTransactionType,
  XPTierType,
  ReferralEarning,
  ClaimMilestoneResponse,
} from "./api/types";
export type { UpdateCardProviderParams } from "./core/updateCardProvider";

// Credit Registry exports
export type {
  CreditProvider,
  CreditProviderId,
  StoreCreditType,
  ProviderKey,
  CreditTypeClassification,
} from "./config/creditRegistry";
export {
  CREDIT_REGISTRY,
  getAllCreditProviders,
  getCreditProvider,
  getCreditProviderByStoreKey,
  getCreditProviderByProviderKey,
  getCreditProvidersByType,
  isCreditProviderOfType,
} from "./config/creditRegistry";
